import React from "react"
import classes from "./StatusLabel.module.scss"
import {useAppSelector} from "../../../../hooks/redux"

interface IStatusLabelProps {
  id: number
  type: "brigade" | "employee" | "order" | undefined
}

function StatusLabel({id, type}: IStatusLabelProps) {

  const {employeeStatuses} = useAppSelector(state => state.handbook)
  const brigadeStatuses = useAppSelector(state => state.brigade.statuses)
  const orderStatuses = useAppSelector(state => state.order.statuses)
  const cls = [classes.wrap]
  let name = ""

  switch (type) {
    case "order":
      const orderStatus = orderStatuses.find(item => item.id === id)

      if (orderStatus) {
        name = orderStatus.name

        switch (orderStatus.id) {
          case 1:
            cls.push(classes.blue)
            break
          case 2:
          case 3:
          case 4:
            cls.push(classes.orange)
            break
          case 5:
          case 6:
            cls.push(classes.green)
            break
          case 7:
            cls.push(classes.red)
            break
          default:
            cls.push(classes.gray)
        }
      } else {
        name = "не определен"
        cls.push(classes.gray)
      }

      break

    case "brigade":
      const brigadeStatus = brigadeStatuses.find(item => item.id === id)

      if (brigadeStatus) {
        name = brigadeStatus.name

        switch (brigadeStatus.id) {
          case 1:
            cls.push(classes.green)
            break
          case 2:
            cls.push(classes.orange)
            break
          default:
            cls.push(classes.gray)
        }
      } else {
        name = "не определен"
        cls.push(classes.gray)
      }

      break

    case "employee":
      const employeeStatus = employeeStatuses.find(item => item.id === id)

      if (employeeStatus) {
        name = employeeStatus.name

        switch (employeeStatus.id) {
          case 1:
            cls.push(classes.green)
            break
          case 2:
            cls.push(classes.orange)
            break
          default:
            cls.push(classes.gray)
        }
      } else {
        name = "не определен"
        cls.push(classes.gray)
      }
  }

  return (
    <div className={cls.join(" ")}>{name}</div>
  )
}

export default StatusLabel